import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import {default as DatasetConfigurations} from 'app/main/configs/datasets/index';
import { RecordService } from './record.service';

export interface DatasetActionContainerServiceInitOptions{
	datasetCode: string;
	datasetRoute?: string;
	parentDatasetACS?: DatasetActionContainerService;
	parentDatasetRS?: RecordService;
	datasetRS?: RecordService;
}

@Injectable()
export class DatasetActionContainerService{
	
	public isReady: BehaviorSubject<boolean>;
	public loading: BehaviorSubject<boolean>;
	
	public datasetCode: string;
	public datasetRoute: string;
	public datasetConfig: any;
	public datasetRS: RecordService;
	public parentDatasetRS: RecordService;
	public parentDatasetACS: DatasetActionContainerService;

	constructor(){
		this.isReady = new BehaviorSubject<boolean>(false);
		this.loading = new BehaviorSubject<boolean>(false);
	}

	// inizializzo configurazioni e non faccio nessun caricamento dati
	init(options: DatasetActionContainerServiceInitOptions): BehaviorSubject<boolean>{
		this.datasetCode = options.datasetCode;
		
		this.datasetConfig = DatasetConfigurations[options.datasetCode];
		if(!this.datasetConfig){
			console.warn('dataset Config not found for', options.datasetCode);
		}

		this.datasetRoute = this.datasetConfig?.datasetRoute || options.datasetRoute;

		this.datasetRS = options.datasetRS;
		this.parentDatasetACS = options.parentDatasetACS;
		this.parentDatasetRS = options.parentDatasetRS;

		this.isReady.next(true);

		return this.isReady;
	}
}
